import { combineReducers } from 'redux';
import { statsLeadersRootSaga } from './stats-leaders/sagas';
import { glossaryRootSaga } from './glossary/sagas';
import { statsLeadersReducer } from './stats-leaders/reducer';
import { statsGlossaryReducer } from './glossary/reducer';
import { seasonLeadersRootSaga } from './season-leaders/sagas';
import { seasonLeadersReducer } from './season-leaders/reducer';
import { lastRoundHighsRootSaga } from './last-round-highs/sagas';
import { lastRoundHighsReducer } from './last-round-highs/reducer';

const sagas = [ statsLeadersRootSaga, glossaryRootSaga, seasonLeadersRootSaga, lastRoundHighsRootSaga ];
const rootReducer = combineReducers( { statsLeaders: statsLeadersReducer, glossary: statsGlossaryReducer, seasonLeaders: seasonLeadersReducer, lastRoundHighs: lastRoundHighsReducer } );

// @ts-expect-error
if ( window.PULSE.app.redux ) {
    // @ts-expect-error
    window.PULSE.app.redux.sagas.statspro.root = sagas;
    // @ts-expect-error
    window.PULSE.app.redux.reducers.statspro.root = rootReducer;
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            statspro: {
                root: rootReducer
            }
        },
        sagas: {
            statspro: {
                root: sagas
            }
        }
    };
}
